import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/imgcaptions/videoStart.svg'
import _imports_1 from '@/assets/imgcaptions/videoStop.svg'
import _imports_2 from '@/assets/sound/aiLogo.png'
import _imports_3 from '@/assets/sound/play2.png'
import _imports_4 from '@/assets/sound/pause2.svg'
import _imports_5 from '@/assets/sound/load.svg'
import _imports_6 from '@/assets/imgcaptions/icon_gongju_11.1.png'
import _imports_7 from '@/assets/svg/loding2.gif'


const _hoisted_1 = { class: "soundCommon" }
const _hoisted_2 = { class: "commonLeft" }
const _hoisted_3 = { class: "rolemodule" }
const _hoisted_4 = { class: "roleLeft" }
const _hoisted_5 = { class: "roleLeftImg" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "roleLeftTitle" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "pathmodule" }
const _hoisted_11 = { class: "pathList" }
const _hoisted_12 = { class: "pathListBox" }
const _hoisted_13 = { class: "pathmodule" }
const _hoisted_14 = { class: "selList" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "parametermodule" }
const _hoisted_17 = { class: "commonLeftBtn" }
const _hoisted_18 = { class: "commonCenter" }
const _hoisted_19 = { class: "commonCenterInner" }
const _hoisted_20 = { class: "centerInnerTop" }
const _hoisted_21 = { class: "InnerTopInner" }
const _hoisted_22 = { class: "topInput" }
const _hoisted_23 = { class: "topInputInner" }
const _hoisted_24 = { class: "topInputBtm" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "topInputBtmNum" }
const _hoisted_28 = { class: "centerInnerBtm" }
const _hoisted_29 = { class: "centerInnerSlider" }
const _hoisted_30 = { class: "innerSliderBox" }
const _hoisted_31 = { class: "innerbtnBox" }
const _hoisted_32 = {
  key: 0,
  class: "innerbtnBoxCenter"
}
const _hoisted_33 = { class: "bottomwavesurfer" }
const _hoisted_34 = {
  id: "timeline",
  class: "wavesurfertimeInner"
}
const _hoisted_35 = {
  class: "wavesurferInner",
  id: "wavesurferId"
}
const _hoisted_36 = { class: "commonRight" }
const _hoisted_37 = { class: "commonRightBox" }
const _hoisted_38 = { class: "historyOne" }
const _hoisted_39 = { class: "historyRowOne" }
const _hoisted_40 = { class: "rowRight" }
const _hoisted_41 = { class: "rowRight" }
const _hoisted_42 = { class: "rowRight" }
const _hoisted_43 = { class: "boxLeft" }
const _hoisted_44 = { class: "rowLeft" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { class: "loadBox" }
const _hoisted_48 = { class: "rowRight" }
const _hoisted_49 = { class: "title" }
const _hoisted_50 = { class: "roleTime" }
const _hoisted_51 = { class: "roleTxt" }
const _hoisted_52 = { class: "timeTxt" }
const _hoisted_53 = { class: "boxRight" }
const _hoisted_54 = { class: "boxRightInner" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = {
  key: 0,
  class: "pieceBoxmask"
}
const _hoisted_57 = { class: "piecedelBox" }
const _hoisted_58 = {
  key: 0,
  class: "pieceBoxmask"
}
const _hoisted_59 = { class: "piecedelPathBox" }
const _hoisted_60 = { class: "pieceBoxmask" }

import {
  computed,
  nextTick,
  onMounted,
  ref,
  toRefs,
  reactive,
  getCurrentInstance,
  watch,
  onBeforeUnmount,
  onUnmounted,
} from "vue";
// 引入页面图标
import { applicationDetail ,soundFieList} from "@/views/captions/icon.ts";
import { ElMessage, ElMessageBox, ElSwitch } from "element-plus";
import {
    Delete,
    Setting,
} from "@element-plus/icons-vue";
import { emotionControl } from '@/components/common/publicTxt.ts'
// 引入录音组件
import record from '../commonPage/recording.vue';
import slider from '../commonPage/slider.vue';
import { languageSound } from '@/components/common/publicTxt.ts'
// 引入情感select切换组件
import emotionRefer from './emotionRefer.vue';
import vectorControl from './vectorControl.vue';
import emotionTxt from './emotionTxt.vue';
//接口引入
import builtSoundApi from "@/api/sound/soundBuilt.ts";
import depotApi from "@/api/sound/depot.ts";
import translationApi from '@/api/common/translate.ts'
// 引入音色市场模块
import timbreMarket from "../commonPage/timbreMarket.vue"
// 引入重命名模块
import rePathbox from '../commonPage/changePath.vue'
// 滑块
import sliderOther from '@/components/common/sliderOther'
import Auth from "@/api/Auth";
import FetchRequest from "@/api/FetchRequest";
import { timedataYmd, timedataHm ,timeInfo,timedata} from '@/components/public-method/time-method';
import WaveSurfer from "wavesurfer.js";
import Timeline from 'wavesurfer.js/dist/plugins/timeline.js';
import Regions, { RegionParams } from 'wavesurfer.js/dist/plugins/regions.js';

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const token = Auth.getToken();
let { proxy } = getCurrentInstance();
// 时间处理方法
let wsRegions: Regions = Regions.create() // Regions 实例
// 生成音轨实例
let wavesurfer: WaveSurfer | null = null;
const topTimeline = Timeline.create({
  container: '#timeline',
  height: 20,
  insertPosition: 'beforebegin',
  style: {
    fontSize: '10px',
    color: '#848485',
    background:'#1B1D1F'
  },
})
const addwaves=()=>{
      wavesurfer = WaveSurfer.create({
            container: document.querySelector('#wavesurferId'),
            waveColor: 'rgba(255, 255, 255, 0.4)',
            progressColor: 'rgba(255, 255, 255, 0.5)',
            cursorColor: 'rgba(255, 255, 255, 1)',
            height: 120,
            cursorWidth: 2,
            url: '',
            // url:proxy.getimgUrlVoice + '/' + audioUrl.value,
            plugins: [topTimeline],
            dragToSeek: true,
        });
        
        wavesurfer?.on('timeupdate', (currentTime) => {
          // console.log(currentTime)
          nowTime.value = Math.ceil(currentTime * 1000)
          totalTime.value = Math.ceil(wavesurfer?.getDuration())* 1000; // 获取总时长（秒）
        })
}
// 
const onprogress=(event:any)=>{
    console.log(event)
}
// 滑块拖拽进度
const elDrak = (data: any) => {
  // console.log(data)
  nowTime.value=data
  let percent=(data/totalTime.value).toFixed(2)
  wavesurfer?.seekTo(percent, 1)
};
onMounted(()=>{
    getChangeSound()
    
    addwaves()
    // 判断是否为跳转
    let soundData=JSON.parse(localStorage.getItem('roleSound'))
    if(soundData!=undefined){
        showRoleOne.value=soundData
    }else{
        getPublic()
    }
})
const loadUrl=(url:string)=>{
//   showlodaing.value=true
    // wavesurfer?.empty()
    wavesurfer?.load(proxy.getimgUrlVoice  +url);
    wavesurfer?.on('loading', (percent) => {
    
        if(percent==100) {
          console.log(percent)
          showlodaing.value=false
         
           
            
          setTimeout(()=>{
            if (!playTypes.value) {
                wavesurfer?.pause()
                playTypes.value=false
                
            } else {
                loadImg.value=false
                wavesurfer?.play()
            }
            
            
          },1000)
          
        }
    })
    wavesurfer?.on('finish', () => {
      wavesurfer?.stop();  // 回到起点
      playTypes.value=false
      changeSoundList.value[selPlayindex.value].isPlay=false

      
    });
    // wavesurfer?.on('ready', function () {
    //         var duration = wavesurfer?.getDuration(); // 获取总时长（秒）
    //         console.log('Total duration:', duration);
    // });
}
onMounted(() => {
  
  proxy.$ws.onmessageTts = (message: any) => {
    // console.log("tts----------");
    // console.log(message);
    getChangeSound()
  }
});
const showlodaing=ref(false)//加载
const emotionType=ref('1')//情感控制
// 参数设置
const nowTime=ref(0)//当前进度
const totalTime=ref(0)//总时间
const audioUrl=ref('ai/voice/original/2025/04/11/55a7ccef04ba460690b08a576631173e.mp3')//音频地址
const playTypes = ref(true);
const marketShow=ref(false)//音色市场弹窗
const openrePathShow=ref(false)//路径弹窗
const pathTxt=ref('/根目录')//路径
const showRoleOne=ref('')
const treeId=ref('0')//上传路径id
const changeSoundList=ref([])//历史记录
const historyTxt=ref('')
const isdisabled=ref(true)
const emoVector=ref([0.5,0.5,0.5,0.5,0.5,0.5,0.5,0.5])//感情控制参数
const textarea=ref('')//语音文本
const language=ref('0')//语言类型
const referList=ref([])//感情参考
const emotxt=ref('')//情感描述文本
const audioRef=ref()
const urlListening=ref('')
const emoVectorData=(data:string)=>{
    emoVector.value=JSON.parse(data) 
}
const referData=(data:string)=>{
    referList.value=JSON.parse(data)
}
const emotxtData=(data:string)=>{
    emotxt.value=data
}
onUnmounted(()=>{
    wavesurfer.pause()
})
const recognition=(data:string)=>{
    showRoleOne.value=JSON.parse(data)
}
// 
watch(textarea,(n,o)=>{
    console.log(n)
    if(n.length==0){
        language.value='0'
        isdisabled.value=true
    }else{
        isdisabled.value=false
    }
})
const changeLanguage=()=>{
    console.log(language.value)
    if(language.value=='0'){
        textarea.value=historyTxt.value
    }else{
        translationApi.getTranstlate(textarea.value,language.value).then(res=>{
            console.log(res)
            textarea.value=res.msg
        })
    }
   
}
const changeTxt=()=>{
    historyTxt.value=textarea.value
}
const playOnoff = () => {
  playTypes.value = !playTypes.value;
  if (!playTypes.value) {
    
    wavesurfer.pause()
  } else {
    wavesurfer.play()
    
    
  }
};
// 获取角色，默认选择公开角色第一个
const getPublic=()=>{
    depotApi.getList(1, 5,1).then((res) => {
        // roleList.value = res.rows;
        console.log(res.rows[0])
        showRoleOne.value=res.rows[0]
        
    });
}

// 打开树形弹窗
const openTree=()=>{
    openrePathShow.value=true
}
const updataTree=(data:any)=>{
    console.log(data)
    openrePathShow.value=false
    pathTxt.value=data[0]
    treeId.value=data[1]
}
// 切换音色
const openMarket=()=>{
    marketShow.value=true
}
// 情感控制
const soundFieChange=()=>{
    console.log(emotionType.value)

}

// 生成变声音频
const toCreatVideo=()=>{
    // console.log(treeId.value)
    // console.log(showRoleOne.value.roleId)
    // console.log(emotionType.value)
    // console.log(textarea.value)
    // console.log(language.value)
    
    let param
    if(textarea.value==''){
        ElMessage({
            type: 'error',
            message: '请上传语音文本',
        })
        return
    }
    if(showRoleOne.value.roleId==undefined){
        ElMessage({
            type: 'error',
            message: '请选择角色',
        })
        return
    }
    if(emotionType.value=='1'){
        param={
            mode:emotionType.value
        }
        builtSoundApi.addSoundBuilt(showRoleOne.value.roleId,language.value,param,treeId.value,textarea.value).then(res=>{
            console.log(res)
            getChangeSound()
        })
    }else if(emotionType.value=='2'){
        console.log(referList.value)
        if(referList.value[0]==''||referList.value[0]==undefined){
            ElMessage({
                type: 'error',
                message: '请上传变声音频',
            })
            return
        }
        param={
            emoAudioPrompt: referList.value[0],
            emoAlpha: referList.value[1] || 0,
            mode:emotionType.value
        }
        console.log(param)
        builtSoundApi.addSoundBuilt(showRoleOne.value.roleId,language.value,param,treeId.value,textarea.value).then(res=>{
            console.log(res)
            getChangeSound()
        })
    }else if(emotionType.value=='3'){
        
        param={
            emoVector: emoVector.value ,
            mode:emotionType.value
        }
        console.log(param)
        builtSoundApi.addSoundBuilt(showRoleOne.value.roleId,language.value,param,treeId.value,textarea.value).then(res=>{
            console.log(res)
            getChangeSound()
        })
    }else if(emotionType.value=='4'){
        if(emotxt.value==''){
            ElMessage({
                type: 'error',
                message: '情感描述文本',
            })
            return
        }
        param={
            emotionDescription: emotxt.value,
            mode:emotionType.value
        }
        console.log(param)
        builtSoundApi.addSoundBuilt(showRoleOne.value.roleId,language.value,param,treeId.value,textarea.value).then(res=>{
            console.log(res)
            getChangeSound()
        })
    }
}
// 查询变声记录
const pageNum=ref(1)//当前页数
const pageSize=ref(20)//每页条数
const total=ref(0)
const getChangeSound=()=>{
    pageNum.value=1
    builtSoundApi.getList(pageNum.value,pageSize.value).then(res=>{
        console.log('查询变声记录')
        console.log(res)
        changeSoundList.value=[]
        // changeSoundList.value=res.rows
        res.rows.forEach(item=>{
            item.isPlay=false
            changeSoundList.value.push(item)
        })
        total.value=res.total
        // changeSoundList.value=groupBySameDay(JSON.parse(JSON.stringify(res.rows)))
        console.log(changeSoundList.value)
    })
}
// 滚动加载

const scrollData = () => {
    
    if(total.value<pageSize.value*pageNum.value){
        return
    }
    pageNum.value+=1
    builtSoundApi.getList(pageNum.value,pageSize.value).then(res=>{
        total.value=res.total
        res.rows.forEach(item=>{
            item.isPlay=false
            changeSoundList.value.push(item)
        })
        // changeSoundList.value.concat(res.rows)
    })
}
// 播放变声
const selPlay=ref('')
const selPlayindex=ref(-1)
const loadImg=ref(false)
const toPlay=(data:any,index:number)=>{
    console.log(data)
    if(data.processedFileUrl==urlListening.value){
        changeSoundList.value[index].isPlay=true
        wavesurfer?.play()
        playTypes.value=true
        return
    }
    selPlay.value=data
    urlListening.value=data.processedFileUrl
    selPlayindex.value=index
    // showlodaing.value=true
    playTypes.value=true
    loadImg.value=true
    changeSoundList.value.forEach((item,num)=>{
        
        if(num==index){
            item.isPlay=true
        }else{
            item.isPlay=false
        }
    })
    
    setTimeout(()=>{
        // totalTime.value=Math.ceil(audioRef.value?.duration*1000) 
        loadUrl(data.processedFileUrl)
        // loadUrl('Algorithm/tts/ai/voice/changed/2025/10/17/kpylogwjrmdssfz.mp3')
    },100)
 
}
// 暂停播放
const audioStop=(index:number)=>{
    changeSoundList.value[index].isPlay=false
    playTypes.value=false
    // audioRef.value?.pause()
    wavesurfer?.pause()
}
// 将数据文件按照时间划分数组
const groupBySameDay=(array:any, timestampKey = 'createTime',batchKey='batch')=> {
  return array.sort((a, b) => b.createTime - a.createTime).reduce((acc:any, item:any) => {
    if(item.batch ==undefined){
        item.batch='batchNo'
    }
    // 将时间戳转换为日期对象
    const date = new Date(item[timestampKey]*1);
    // 创建只包含年月日的日期字符串作为键
    const dayKey = date.toLocaleDateString('en-CA'); // 格式: YYYY-MM-DD
    
    if (!acc[dayKey]) {
      acc[dayKey] = {};
    }
    
    
    // 每一天内按用户分组区分是否为批量
    const batchId=item[batchKey];
    if (!acc[dayKey][batchId]) {
      acc[dayKey][batchId] = [];
    }
      
    acc[dayKey][batchId].push(item);
    return acc;
  }, {});
}
const downThis=(data:any)=>{
    console.log('下载')
    console.log(data)
    const a = document.createElement("a");
  //   let url = baseUrl + binding.value // 若是不完整的url则需要拼接baseURL
  const url = proxy.getimgUrlVoice +data.processedFileUrl; // 完整的url则直接使用
  // 这里是将url转成blob地址，
  
  fetch(url)
    .then((res) => res.blob())
    .then((blob) => {
      // 将链接地址字符内容转变成blob地址
      a.href = URL.createObjectURL(blob);
      // console.log(a.href)
      a.download = data.roleName; // 下载文件的名字
      // a.download = url.split('/')[url.split('/').length -1] //  // 下载文件的名字
      document.body.appendChild(a);
      a.click();
    });
}
// 删除
const delOneChange=(data:any)=>{
    console.log('删除')
    builtSoundApi.delSoundBuilt(data.id).then(res=>{
        console.log(res)
        getChangeSound()
    })
}


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: _unref(proxy).getimgUrlVoice + showRoleOne.value.avatar
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(showRoleOne.value.name), 1),
            _createElementVNode("span", _hoisted_9, _toDisplayString(showRoleOne.value.intro), 1)
          ])
        ]),
        _createElementVNode("div", {
          class: "roleright",
          onClick: _withModifiers(openMarket, ["stop"])
        }, " 更换音色 ")
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "moduleTitle" }, " 输出目录 ", -1)),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(pathTxt.value), 1),
          _createElementVNode("div", {
            class: "pathListBtn",
            onClick: _withModifiers(openTree, ["stop"])
          }, [
            _createVNode(_component_el_icon, {
              color: "#fff",
              size: "24"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Setting))
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "moduleTitle" }, " 情感控制方式 ", -1)),
        _createElementVNode("div", _hoisted_14, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((emotionType).value = $event)),
            class: "parameterSel",
            onChange: soundFieChange
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(emotionControl), (item, index) => {
              return (_openBlock(), _createElementBlock("option", {
                value: item.value,
                key: index
              }, _toDisplayString(item.text), 9, _hoisted_15))
            }), 128))
          ], 544), [
            [_vModelSelect, emotionType.value]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        (emotionType.value=='2')
          ? (_openBlock(), _createBlock(emotionRefer, {
              key: 0,
              onReferData: referData
            }))
          : _createCommentVNode("", true),
        (emotionType.value=='3')
          ? (_openBlock(), _createBlock(vectorControl, {
              key: 1,
              onEmoVectorData: emoVectorData
            }))
          : _createCommentVNode("", true),
        (emotionType.value=='4')
          ? (_openBlock(), _createBlock(emotionTxt, {
              key: 2,
              onEmotxtData: emotxtData
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", {
          class: "videoBtn",
          onClick: _withModifiers(toCreatVideo, ["stop"])
        }, "生成音频")
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "topTitle" }, " 语音文本", -1)),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_el_input, {
                  modelValue: textarea.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((textarea).value = $event)),
                  maxlength: "5000",
                  style: {"height":"100%"},
                  placeholder: "请输入要生成的文字内容",
                  type: "textarea",
                  resize: "none",
                  onChange: changeTxt
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((language).value = $event)),
                  class: "toselect",
                  disabled: isdisabled.value,
                  onChange: changeLanguage
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languageSound), (item, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: item.value,
                      key: index
                    }, _toDisplayString(item.text), 9, _hoisted_26))
                  }), 128))
                ], 40, _hoisted_25), [
                  [_vModelSelect, language.value]
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("span", null, _toDisplayString(textarea.value.length), 1),
                  _cache[7] || (_cache[7] = _createTextVNode("/")),
                  _cache[8] || (_cache[8] = _createElementVNode("span", null, "5000", -1))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _withDirectives(_createVNode(_unref(sliderOther), {
                num: nowTime.value,
                max: totalTime.value,
                onUpdataNum: elDrak
              }, null, 8, ["num", "max"]), [
                [_vShow, audioUrl.value !=''&& !showlodaing.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              (selPlay.value!='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _createVNode(_component_el_tooltip, {
                      class: "box-item",
                      effect: "dark",
                      content: "播放",
                      placement: "bottom"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("img", {
                          src: _imports_0,
                          onClick: playOnoff
                        }, null, 512), [
                          [_vShow, !playTypes.value]
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_tooltip, {
                      class: "box-item",
                      effect: "dark",
                      content: "暂停",
                      placement: "bottom"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("img", {
                          src: _imports_1,
                          onClick: playOnoff
                        }, null, 512), [
                          [_vShow, playTypes.value]
                        ])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _cache[10] || (_cache[10] = _createElementVNode("div", null, null, -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _withDirectives(_createElementVNode("div", _hoisted_34, null, 512), [
              [_vShow, audioUrl.value !='']
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_35, null, 512), [
              [_vShow, audioUrl.value !='']
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_36, [
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "commonRightTitle" }, "生成历史", -1)),
      _createElementVNode("div", _hoisted_37, [
        _createVNode(_component_el_scrollbar, {
          height: "100%",
          style: {"width":"100%"},
          onScroll: scrollData
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(changeSoundList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "historyList",
                key: index
              }, [
                _createElementVNode("div", _hoisted_38, [
                  _withDirectives(_createElementVNode("div", _hoisted_39, [
                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "rowLeft" }, [
                      _createElementVNode("img", {
                        src: _imports_2,
                        alt: ""
                      })
                    ], -1)),
                    _withDirectives(_createElementVNode("div", _hoisted_40, "音频待处理", 512), [
                      [_vShow, item.status==0]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_41, "音频生成中", 512), [
                      [_vShow, item.status==1]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_42, "生成失败", 512), [
                      [_vShow, item.status<0]
                    ]),
                    _createVNode(_component_el_icon, {
                      color: "#C8C9C9",
                      onClick: _withModifiers(($event: any) => (delOneChange(item)), ["stop"]),
                      class: "historyRowOneDel"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Delete))
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ], 512), [
                    [_vShow, item.status<2]
                  ]),
                  _createElementVNode("div", {
                    class: "historyRowTwo",
                    style: _normalizeStyle(item.status<2?{'paddingTop':'38px'}:'' || selPlayindex.value==index?{'background':'#000'}:'')
                  }, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _withDirectives(_createElementVNode("img", {
                          src: _imports_3,
                          alt: "",
                          onClick: _withModifiers(($event: any) => (toPlay(item,index)), ["stop"])
                        }, null, 8, _hoisted_45), [
                          [_vShow, (!item.isPlay&&!loadImg.value)||selPlayindex.value!=index]
                        ]),
                        _withDirectives(_createElementVNode("img", {
                          src: _imports_4,
                          alt: "",
                          onClick: _withModifiers(($event: any) => (audioStop(index)), ["stop"])
                        }, null, 8, _hoisted_46), [
                          [_vShow, item.isPlay&&!loadImg.value]
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_47, _cache[12] || (_cache[12] = [
                          _createElementVNode("img", {
                            src: _imports_5,
                            alt: "",
                            class: "loadBoxImg"
                          }, null, -1)
                        ]), 512), [
                          [_vShow, item.isPlay&&loadImg.value&&selPlayindex.value==index]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, _toDisplayString(item.text), 1),
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, _toDisplayString(item.roleName), 1),
                          _createElementVNode("div", _hoisted_52, _toDisplayString(_unref(timedata)(item.createTime*1)), 1)
                        ])
                      ])
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_53, [
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("img", {
                          src: _imports_6,
                          alt: "",
                          onClick: _withModifiers(($event: any) => (downThis(item)), ["stop"])
                        }, null, 8, _hoisted_55),
                        _createVNode(_component_el_icon, {
                          color: "#C8C9C9",
                          onClick: _withModifiers(($event: any) => (delOneChange(item)), ["stop"])
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Delete))
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ], 512), [
                      [_vShow, item.status==2]
                    ])
                  ], 4)
                ])
              ]))
            }), 128))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", null, [
      (marketShow.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _createVNode(timbreMarket, {
                isChange: false,
                onCloseThis: _cache[3] || (_cache[3] = ($event: any) => (marketShow.value = false)),
                onRecognition: recognition
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      (openrePathShow.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _createVNode(rePathbox, {
                onCloseThis: _cache[4] || (_cache[4] = ($event: any) => (openrePathShow.value = false)),
                onUpparentId: updataTree
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_60, _cache[14] || (_cache[14] = [
      _createElementVNode("div", { class: "maskBox" }, [
        _createElementVNode("img", {
          src: _imports_7,
          style: {"width":"90px","height":"90px"}
        }),
        _createElementVNode("span", null, "正在加载资源中，请稍候...")
      ], -1)
    ]), 512), [
      [_vShow, showlodaing.value]
    ])
  ]))
}
}

})